/**
 * Fictora 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Fictora 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '',
  // 标签模块背景图（fictora 不显示背景）
  tagsBg: '',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#FF2D89',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#FF8AB9',
  tagInactiveText: '#FFFFFF',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F4F1FF 0%, #FF2D89 95%)',
  // 不显示 Tab 热点图标
  showHotTabIcon: false,
  // 顶部 Banner 撑满屏宽，无底部圆角
  topBannerRadius: '0',
  // 顶部 Banner 底部渐变蒙层（过渡到 home-bg 全局背景 #050000，确保无缝衔接）
  topBannerBottomGradient: 'linear-gradient(180deg, rgba(5,0,0,0) 0%, #050000 100%)',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
